const nestedFolder = {
  id: 2,
  name: 'Sample Child Folder',
  folder: true,
  icon: 'folder',
  createdBy: 'Conan Obrien',
  lastModified: 'Tue Jun 09 2020 11:34:22 GMT-0500',
  children: [
    {
      id: 3,
      name: 'Test.jpg',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Jun 09 2020 11:54:23 GMT-0500',
      icon: 'jpg',
      size: '12 MB',
      url: '/assets/logos/buildout.png'
    },
    {
      id: 4,
      name: 'Foo.csv',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Jun 09 2020 11:14:23 GMT-0500',
      icon: 'csv',
      size: '13 MB',
      url: '/assets/sample.csv'
    },
    {
      id: 9,
      name: 'word.docx',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Jun 09 2020 10:33:23 GMT-0500',
      icon: 'doc',
      size: '13 MB',
      url: 'https://file-examples-com.github.io/uploads/2017/02/file-sample_100kB.doc'
    },
    {
      id: 10,
      name: 'slideshow.ppt',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Jun 09 2020 11:34:23 GMT-0500',
      icon: 'ppt',
      size: '13 MB',
      url: 'https://scholar.harvard.edu/files/torman_personal/files/samplepptx.pptx'
    },
    {
      id: 11,
      name: 'spreadsheet.xls',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Jun 09 2020 11:38:23 GMT-0500',
      icon: 'xls',
      size: '13 MB',
      url: 'https://file-examples-com.github.io/uploads/2017/02/file_example_XLS_10.xls'
    }
  ]
};

const rootFolder = {
  id: 1,
  folder: true,
  icon: 'folder',
  children: [
    nestedFolder,
    {
      id: 11,
      name: 'testdoc',
      createdBy: 'Reese Witherspoon',
      icon: 'bo-doc',
      size: '8 KB',
      url: 'http://localhost:3000/docs/documents/1?token=2001fd890bde6e7be8dff380367f3b38275e354a'
    },
    {
      id: 6,
      name: 'buildout.pdf',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Mar 30 2021 11:33:41 GMT-0500',
      icon: 'pdf',
      size: '8 KB',
      url: '/some_document.pdf'
    },
    {
      id: 7,
      name: 'video.mp4',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Mar 30 2021 11:38:44 GMT-0500',
      icon: 'vid',
      size: '8 GB',
      url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
    },
    {
      id: 8,
      name: 'words.txt',
      createdBy: 'Conan Obrien',
      lastModified: 'Tue Mar 30 2021 12:13:11 GMT-0500',
      icon: 'txt',
      size: '8 GB',
      url: '/robots.txt'
    },
    {
      id: 5,
      name: 'Empty Sample Folder',
      folder: true,
      icon: 'folder',
      children: []
    }
  ],
  name: 'Sample Folder'
};

export default rootFolder;
